<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Manual Deposit</h5>
      <div class="row">
        <div class="col">
          <div class="alert alert-warning" v-show="showManualDepositInfo">
            <p class="text-dark">
              Terkadang beberapa transaksi terlewat dari proses auto
              singkronisasi yang mungkin ada faktor eksternal diluar aplikasi
              kami.
            </p>
            <p class="text-dark">
              Kamu dapat memasukkan transaksi hash pada input dibawah ini.
              <span
                style="
                  font-weight: bold;
                  cursor: pointer;
                  text-decoration: underline;
                  color: blue;
                "
                @click="showManualDepositFormAction"
              >
                here
              </span>
            </p>
          </div>

          <form
            @submit.prevent="submitFormManualDeposit"
            v-show="showManualDepositForm"
          >
            <div class="form-row mt-4">
              <div class="col-md-12">
                <label>Chain ID:</label>
                <select
                  v-model="manualDeposit.chain_contract"
                  class="form-control"
                >
                  <option
                    v-for="item in evm_tokens"
                    :key="item.id"
                    :value="`${item.chain_id}-${item.contract_address}`"
                  >
                    {{ item.chain_id }} - {{ item.contract_address }}
                  </option>
                </select>
              </div>
              <div class="col-md-12">
                <label>Tx Hash:</label>
                <input
                  type="text"
                  v-model="manualDeposit.txhash"
                  class="form-control"
                />
              </div>

              <div class="col-md-12 mt-2">
                <button type="submit" class="btn btn-light">Submit</button>
                <a href="#" @click="showManualDepositInfoAction"> Cancel </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components

export default {
  components: {},
  props: {
    currency: {
      type: String,
      required: true,
    },
    activeCurrencyObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      ethereumAddress: "",
      evm_tokens: [],

      showManualDepositInfo: true,
      showManualDepositForm: false,

      manualDeposit: {
        txhash: "",
        chain_contract: "",
      },
    };
  },

  async mounted() {
    var self = this;
    self.getEvmTokens();
  },

  methods: {
    async getEvmTokens() {
      var self = this;
      var res = await thestore.getEvmTokensByCcurrencyId(
        self.activeCurrencyObj.id
      );
      self.evm_tokens = res.filter((token) => token.tracking); // Filter hanya tampilkan yang tracking = true
    },

    showManualDepositFormAction() {
      var self = this;
      self.showManualDepositInfo = false;
      self.showManualDepositForm = true;
    },
    showManualDepositInfoAction() {
      var self = this;
      self.showManualDepositInfo = true;
      self.showManualDepositForm = false;
    },

    async submitFormManualDeposit() {
      var self = this;
      var res;

      if (self.activeCurrencyObj.ccurrency_kind == "evm_token") {
        // karena selectnya tidak kita buat :value, maka kita parsing saja isiannya
        var chain_contract = self.manualDeposit.chain_contract.split("-");

        res = await thestore.postEvmTokenManualDeposit(
          self.token,
          chain_contract[0],
          self.manualDeposit.txhash,
          chain_contract[1],
          self.currency
        );
        if (res.success == true) {
          alert("Success");
          self.$router.go();
        } else {
          alert(res.msg);
        }
      }
    },
  },
};
</script>
